<div class="flxRow w100 h100" style="justify-content: space-between;">
    <input #digitInput
           *ngFor="let num of [].constructor(length); let i = index"
           type="number" maxlength="1" pattern="[0-9]{10}"
           [ngClass]="{'validation-error' : (localDigitModels && localDigitModels.length && localDigitModels[i].error) || incorrect}"
           (keydown)="keyDown(i, $event)"
           (paste)="onPaste($event)">
</div>
